import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const SupplierService = {

  getAllSupplier: async () => {
    try {
      const response = await axios.get(ENDPOINT.Supplier);
      return response.data;
    } catch (error) {
      console.error("Error fetching Suppliers:", error.message);
      throw error;
    }
  },

  getSupplierStats: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Supplier}/stats`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Supplier stats:", error.message);
      throw error;
    }
  },

  getDistinctValues: async (field) => {
    try {
      const response = await axios.get(`${ENDPOINT.Supplier}/distinct/${field}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching distinct values:", error.message);
      throw error;
    }
  },

  getLastSupplier: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Supplier}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching last Supplier:", error.message);
      throw error;
    }
  },

  getSupplierById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Supplier}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Supplier:", error.message);
      throw error;
    }
  },

  createSupplier: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Supplier, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating Supplier:", error.message);
      throw error;
    }
  },

  updateSupplier: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Supplier}/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating Supplier:", error.message);
      throw error;
    }
  },

  deleteSupplier: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Supplier}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting Supplier:", error.message);
      throw error;
    }
  },
};